<template>
  <div class="singlebar">
     <div class="title m-b-10">
       <strong :style="{color: colorCode}">{{ title }}</strong> {{ statusCount }} out of {{ totalDrafts }}
     </div>
     

     <div class="percentBar">
       <div class="percentTxt">
         {{ calculateWidth }}
       </div>
       <div class="outerbar">
         <div class="innerbar" :style="{width: calculateWidth, backgroundColor: colorCode}"></div>
       </div>
     </div>
     <div class="note p-t-5" v-if="note" >{{ note }}</div>
  </div>
</template>

<script>
  export default {
     props: {
       statusCount: {
          type: Number,
          default: 0
       },
       title: {
         type: String,
         default: 'Status'
       },
       totalDrafts: {
         type: Number,
         default: 0
       },
       colorCode:{
         type: String,
         default: 'rgb(146, 146, 146);'
       },
       note: {
         type: String,
         default: ''
       }
     },
     computed: {
       calculateWidth(){
          return `${((this.statusCount / this.totalDrafts) * 100).toFixed(2)}%`;
       }
     }
  }
</script>

<style lang="scss" scoped>
  .percentBar{
    padding-left:55px;
    position: relative;
    .percentTxt{
      position: absolute;
      left: 0;
      top:0;
      font-size: 13px;
    }
  }
  .singlebar{
     margin-bottom: 30px;
  }
  .outerbar{
     height: 5px;
     background-color: rgb(231, 231, 231);
     border-radius: 30px;
     overflow: hidden;
     position: relative;
     top: 6px;
  }
  .innerbar{
     height: 5px;
     transition: all 1s ease-in;
  }
  .title{
    font-size: 13px;
  }
  .note{
    font-size: 11px;
    color: rgb(121, 121, 121);
    margin-top: 5px;
  }
</style>